import { ImageType } from '@types';
import Image from '@components/Image';
import useEditingStore from '@hooks/useEditingStore';
import { CustomButtonWidget } from '@modules/player/SceneWidgets/CustomButtonWidget';
import { $tourData } from '@stores/dataStores';
import { $GateSearchBtn } from '@stores/editingStores';

export function RightSideButtons() {
  const showSearch = useEditingStore({
    $data: $tourData,
    dataFn: (state) => !!state.config?.search?.enabled,
    $editing: $GateSearchBtn.state,
  });

  return (
    <div className="absolute right-20">
      <CustomButtonWidget />
      {showSearch && (
        <div className="mt-10 flex w-50 flex-col items-center justify-center gap-20 rounded bg-black-black bg-opacity-50 py-10">
          <Image
            src="/imgs/search.4e1549dd38bdb38a07a3fc96c7b9495a.png"
            type={ImageType.sysMedia}
            className="h-30 w-30"
          />
        </div>
      )}
    </div>
  );
}
